import {toInt} from '@/library/math';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const LogList      = () => import(/* webpackChunkName: "log" */ '../views/log/LogList.vue');
const LogSettings  = () => import(/* webpackChunkName: "log" */ '../views/log/LogSettings.vue');
const LogEntryView = () => import(/* webpackChunkName: "log" */ '../views/log/LogEntryView.vue');

const meta: MetaData = {
    module: 'log',
};

let routes: RouteRecordRaw[] = [
    {
        name: 'log',
        path: '/log',
        redirect: {
            name: 'log-list',
        },
    },
    {
        name: 'log-list',
        path: '/log/list',
        component: LogList,
        meta,
    },
    {
        name: 'log-settings',
        path: '/log/settings/:route(intranet)?',
        component: LogSettings,
        meta,
        children: [
            {
                name: 'log-settings-general',
                path: 'general',
                meta,
                component: LogSettings,
            },
            {
                name: 'log-settings-deletion',
                path: 'deletion',
                meta,
                component: LogSettings,
            },
            {
                name: 'log-settings-notifications',
                path: 'notifications',
                meta,
                component: LogSettings,
            },
        ],
    },
    {
        name: 'log-entry-view',
        path: '/log/entry/view/:id(\\d+)?',
        component: LogEntryView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: toInt(route.params.id),
            };
        },
    },

    /* compatibility routes */
    {
        path: '/log',
        redirect: {
            name: 'log-list',
        },
    },
    {
        path: '/log/list',
        redirect: {
            name: 'log-list',
        },
    },
    {
        path: '/log/:wildcard*',
        redirect: {
            name: 'log-list',
        },
    },
];

export default routes;